// -----------------------------------
// Article Template
// -----------------------------------
if($('blockquote')) { 
  $('blockquote').addClass('article-blockquote'); 
  var blockquote = $('blockquote').text(); 
  var text = blockquote.substr(0, blockquote.indexOf('-')); 
  var citation = blockquote.substr(blockquote.indexOf('-') + 1); 

  // Clear Text
  $('blockquote').text('');

  // Create a new element
  var elem = "<p>" + text + "</p>" + "<p class='article-blockquote__cite'>" + citation + "</p>";

  // Add element to blockquote
  $('blockquote').append(elem); 
}
 
// -----------------------------------
// Blog Template
// -----------------------------------

$('.view-posts').each(function() { 
  $(this).on('click', function(e) { 
    e.preventDefault();

    var viewMore = $(this).parent().parent().parent().find('.blog-posts--more'); 

    if(viewMore.hasClass('js-hide')) { 

      viewMore.removeClass('js-hide'); 
      viewMore.addClass('js-show');
      $('.view-posts').text('View Less'); 

    } else {

      viewMore.removeClass('js-show'); 
      viewMore.addClass('js-hide'); 
      $('.view-posts').text('View All'); 
    }
  });
}); 

$('.view-all').addClass('hide');

if($('.blog-featured .blog-post').length > 4) { 
  $('.view-all').removeClass('hide'); 
} 

$('.blog-featured .blog-post:nth-child(n+5').addClass('hide'); 

$('.view-all').on('click change', function(e) { 
  e.preventDefault();
  var blogPosts = $('.blog-featured .blog-posts'); 
  var blogPost = $('.blog-featured .blog-post:nth-child(n+5)');

  if(blogPost.hasClass('hide')) { 
    blogPost.removeClass('hide'); 
    blogPost.addClass('show'); 
    $('.view-all').text('View Less');  
  } else { 
    blogPost.removeClass('show'); 
    blogPost.addClass('hide'); 
    $('.view-all').text('View All'); 
  }
}); 

// Related Posts
$( ".article .blog-post" ).wrapAll( "<div class='related-post__more' />");



$(document).ready(function() {
  $('label .rounded-circle').each(function() {
    if($(this).attr('data-link') == $(this).attr('data-label')) {
      $(this).css('display', 'block');
    }
  });
});





















